// src/modules/app-views/_apps/appmulti/quotations/List/Modals/CoveragesModal.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DownloadOutlined } from '@ant-design/icons';
import { Button, Card, Col, Flex, Modal, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import appmultiService from 'modules/app-views/_apps/appmulti/services/appmultiService';
import { downloadFile } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const MultiQuotationCoveragesModal = props => {
  const { record, showModal, setShowModal, setSelectedRecord } = props;

  // HANDLERS
  const onClose = () => {
    setSelectedRecord && setSelectedRecord(null);
    setShowModal(false);
  };

  const onDownloadFile = () => {
    if (!record?.coveragesFileUrl || !record?.name) return;
    downloadFile(record.coveragesFileUrl, `COBERTURAS ${record.name.toUpperCase()}.pdf`);
  };

  // RENDER
  const coverages = record?.coverages || [];

  return (
    <Modal
      cancelButtonProps={{ style: { display: 'none' } }}
      okText="Fechar"
      okButtonProps={{ type: 'primary' }}
      title={<div className="text-muted text-uppercase mb-4">{record?.name}</div>}
      open={showModal}
      onCancel={onClose}
      onOk={onClose}
    >
      {record?.coverageAdditionalInfo && (
        <Card title={translateX('additional_info_singular')}>
          <Row gutter={ROW_GUTTER} className="w-100">
            <Col span={24}>
              <div style={{ whiteSpace: 'pre-line' }}>
                {record.coverageAdditionalInfo.replace(/<br\s*\/?>/gi, '\n')}
              </div>
            </Col>
          </Row>
        </Card>
      )}

      <Card>
        {coverages.map((coverage, index) => {
          const type = coverage?.type;
          const showValue = type === 'money' || type === 'text' || type === 'switch';
          const keySpan = showValue ? 16 : 22;
          const displayValue =
            type === 'switch'
              ? translateX('yes')
              : appmultiService.getCoverageValue(coverage, false) || '-';
          return (
            <Row gutter={ROW_GUTTER} key={coverage._id || index} style={{ marginBottom: 24 }}>
              <Col xs={24} sm={keySpan}>
                <div>{translateX(coverage.coverageKey)}</div>
              </Col>
              {showValue && (
                <Col xs={24} sm={6} className="text-center">
                  <div>{displayValue}</div>
                </Col>
              )}
            </Row>
          );
        })}

        {record?.coveragesFileUrl && (
          <Flex justify="flex-start">
            <Button type="link" icon={<DownloadOutlined />} onClick={onDownloadFile}>
              Download
            </Button>
          </Flex>
        )}
      </Card>
    </Modal>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default MultiQuotationCoveragesModal;
